/* import __COLOCATED_TEMPLATE__ from './security-models-data-sharing.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type ModelTrainingConsentOptOutRequest from 'embercom/models/model-training-consent-opt-out-request';

interface SecurityModelsDataSharingArgs {
  dataSharingOptOut?: ModelTrainingConsentOptOutRequest;
}

export default class SecurityModelsDataSharing extends Component<SecurityModelsDataSharingArgs> {
  @service declare appService: AppService;
  @service declare regionService: any;

  get app() {
    return this.appService.app;
  }

  get shouldShowRegionalOptOut() {
    return this.regionService.isEU || this.regionService.isAU;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing': typeof SecurityModelsDataSharing;
    'new-settings/workspace/security-models-data-sharing': typeof SecurityModelsDataSharing;
  }
}
